import { PERSISTENCE_STATE_KEYS } from "../../../other/constants/PersistenceStateKeys.jsx";
import { HasReminderBaseMixin } from "../../widget/mixins/HasReminderBaseMixin.jsx";
import ClientsEditorBase from "./ClientsEditorBase.jsx";
import {ALERT_TYPES, ReminderTypes} from "../../../other/constants/OtherKeys.jsx";

export default class ClientRemindersTab extends HasReminderBaseMixin(
  ClientsEditorBase
) {
  static get $name() {
    return "ClientRemindersTab";
  }

  static get type() {
    return "clientreminderstabv2";
  }

  get swivuDeepLinkSlug() {
    return "reminders";
  }

  get stateId() {
    return PERSISTENCE_STATE_KEYS.clientEditorReminderTab;
  }

  get recordType() {
    return "clientId";
  }

  getStoreData() {
    return this.project.reminderStore.query(
      (reminder) => reminder.entityType === this.entityType && reminder[this.recordType] === this.record.id && reminder.alertType === ALERT_TYPES.REMINDER && reminder.alertTag === "Reminder",
      true
    );
  }

  get entityType() {
    return ReminderTypes.client;
  }
}

ClientRemindersTab.initClass();
